import { Link, usePage } from '@inertiajs/react';
import Navbar from '@/Components/Main/navbar';
import Footer from '@/Components/Main/footer';
import { useInView } from 'react-intersection-observer';

export default function Layout({ children }) {

    const navbarRef = useInView({ triggerOnce: true, threshold: 0.3 });

    const footerRef = useInView({ triggerOnce: true, threshold: 0.3 });

    const { footerData } = usePage().props;
    const { kategorieFooter } = usePage().props;
    const { menuData } = usePage().props;
    const { auth } = usePage().props;

    return (
        <>

            <div ref={navbarRef.ref} className={`fade-in-section ${navbarRef.inView ? 'is-visible' : ''}`}><Navbar menu={menuData} auth={auth} /></div>
            {children}
            <div ref={footerRef.ref} className={`fade-in-section ${footerRef.inView ? 'is-visible' : ''}`}><Footer footer={footerData} kategorie={kategorieFooter} /></div>

        </>
    );
}
